/**
 * The machine-readable outcome-routing guide shared by the `get_job` and `wait`
 * tool descriptions, so an agent learns — from either tool — how to switch on a
 * job's outcome using the (`status`, `modifier`, `passStatus`) triple rather than
 * guessing from `passStatus` alone.
 *
 * Canonical field definitions live in `@runhuman/shared`
 * (`job/job-status.ts`, `job/pass-status.ts`); this string is the consumer-facing
 * restatement, kept in one place to avoid drift between the two tool blurbs.
 */
export const OUTCOME_BUCKETS_GUIDE = `Outcome buckets — route on (status, modifier, passStatus), not passStatus alone:
- passed              → status=completed + passStatus=pass
- failed (broken)     → status=completed + passStatus=fail
- inconclusive        → status=completed + passStatus=not_applicable
- environment-blocked → status=failed + modifier=unreachable_url | safety_check_failed | platform_issue
- tester-abandoned    → status=expired + modifier=tester_dropped | tester_unresponsive | no_capacity
- cancelled           → status=cancelled + modifier=tester_cancellation | tester_invalidated | admin_terminated
- still running       → any active status (pending/preparing/queued/waiting/working/overdue/admin_hold)

passStatus is only meaningful once status=completed. A null/absent passStatus is NOT "still pending" — read status to tell them apart.`;
